import anaUtils from 'analytics/utils';
import anaConsts from 'analytics/constants';
import processEvent from 'analytics/processEvent';
import bindingMethods from 'analytics/bindingMethods/pages/all/generalBindings';
const { PAGE_NAMES, SOT_LINK_TRACKING_EVENT } = anaConsts;

const LABELS_MAP = {
    shopMyStore: PAGE_NAMES.SHOP_YOUR_STORE,
    shopSameDay: PAGE_NAMES.SHOP_SAME_DAY,
    storeDetails: 'store details',
    findASephora: 'find a sephora',
    servicesAndEvents: 'services and events'
};
const SHOP_STORE = 'shop-store';
const SHOP_SAMEDAY = 'shop-sameday';
const PAGE_TYPE = 'happening at sephora';

export const SYS_SEARCH_LINK_DATA = {
    SYS_SEARCH_BAR: 'sys search:sys search bar',
    GLOBAL_SEARCH_BAR: 'sys search:global search bar'
};

class ShopYourStoreBindings {
    static triggerSOTAnalytics = ({ eventData }) => {
        processEvent.process(SOT_LINK_TRACKING_EVENT, {
            data: eventData
        });
    };

    static setChicletNextPageData() {
        const nextPageData = {
            // prop55 and eVar64
            linkData: 'top nav - my store click',
            navigationInfo: anaUtils.buildNavPath(['top nav', 'my store'])
        };

        anaUtils.setNextPageData(nextPageData);
    }

    static setFlyoutNextPageData(elementId) {
        if (!elementId) {
            return;
        }

        const labelName = LABELS_MAP[elementId] || elementId;

        const nextPageData = {
            // linkData - prop55 for next page load
            linkData: `shop store fly out:${labelName} click`
        };

        anaUtils.setNextPageData(nextPageData);
    }

    static shopSameDayPageLoad(sameDayAvailable) {
        const shopSameDay = PAGE_NAMES.SHOP_SAME_DAY.replace(/\s+/g, '-');

        // happening at sephora:shop-same-day-delivery:n/a:*sdd=true
        const pageName = `${PAGE_TYPE}:${shopSameDay}:n/a:*sdd=${sameDayAvailable}`;

        digitalData.page.category.pageType = PAGE_TYPE;
        digitalData.page.pageInfo.pageName = pageName;

        const { zipcode } = ShopYourStoreBindings.getStoreDetails();

        /*
            SOT - Page View (shop same day)
            sotV01:     mapped to pageDetail  (value: "shop same-day delivery")
            sotSubType: mapped to pageType    (value: "happening at sephora")
            sotV447:    mapped to zipcode     (identifier: zipcode in previousPageInfo.attributes)
        */
        digitalData.page.previousPageInfo = {
            ...digitalData.page?.previousPageInfo,
            attributes: {
                ...digitalData.page?.previousPageInfo?.attributes,
                zipcode
            }
        };

        processEvent.process(anaConsts.PAGE_LOAD);
    }

    static shopMyStorePageLoad(isBopisable) {
        const shopYourStore = PAGE_NAMES.SHOP_YOUR_STORE.replace(/\s+/g, '-');

        // happening at sephora:shop-your-store:n/a:*pickup=true
        const pageName = `${PAGE_TYPE}:${shopYourStore}:n/a:*pickup=${isBopisable}`;

        digitalData.page.category.pageType = PAGE_TYPE;
        digitalData.page.pageInfo.pageName = pageName;

        const { storeDetailId, storeDetailName } = ShopYourStoreBindings.getStoreDetails();

        /*
            SOT - Page View
            sotV01:     mapped to pageDetail
            sotSubType: mapped to pageType
            sotV328:    mapped to storeName
            sotV193:    mapped to storeId
        */
        digitalData.page.previousPageInfo = {
            ...digitalData.page?.previousPageInfo,
            attributes: {
                ...digitalData.page?.previousPageInfo?.attributes,
                preferredStoreId: storeDetailId,
                storeName: storeDetailName
            }
        };
        processEvent.process(anaConsts.PAGE_LOAD);
    }

    static buildInternalCampaignString(item, sectionTitle) {
        const sid = item?.sid;
        const title = item?.title;
        let source = '';

        if (sid.startsWith(SHOP_STORE)) {
            source = LABELS_MAP['shopMyStore'];
        } else if (sid.startsWith(SHOP_SAMEDAY)) {
            source = LABELS_MAP['shopSameDay'];
        }

        const result = encodeURIComponent(`${source}:${sectionTitle}:${title} click`.toLowerCase());

        return result;
    }
    //STAG Analytics
    static sendSOTLinkTrackingClickEvent({ eventData }) {
        ShopYourStoreBindings.triggerSOTAnalytics({ eventData });
    }

    static getStoreDetails() {
        const storeDetails = bindingMethods.getShopYourStorePreferences();
        const [zipcode = '', storeDetailId = '', storeDetailName = ''] = storeDetails.split(':');

        return { zipcode, storeDetailId, storeDetailName };
    }
}

export default ShopYourStoreBindings;
